import { centsToBrlInput, parseBrlToCents } from "@/lib/price";
import { formatPercentInput, parsePercentInput } from "@/lib/pricing";
import type { Product, ProductInput } from "@/types/models";
import {
  bomLinesToInput,
  type ProductBomLine,
} from "../components/ProductBillOfMaterialsEditor";

export function productToBomLines(product: Product): ProductBomLine[] {
  return (product.productRawItems ?? []).map((line) => ({
    rawItemId: line.rawItem.id,
    quantity: String(line.quantity),
  }));
}

function parseOptionalPercent(value: string): number | null | undefined {
  const parsed = parsePercentInput(value);
  if (value.trim() === "") return null;
  return parsed === null ? undefined : parsed;
}

export interface ProductPricingFormValues {
  cost: string;
  staticCost: string;
  price: string;
  markupPercent: string;
  targetNetMarginPercent: string;
  effectiveTaxPercent: string;
}

export function productToPricingFormValues(product: Product): ProductPricingFormValues {
  return {
    cost: product.costCents != null ? centsToBrlInput(product.costCents) : "",
    staticCost:
      product.staticCostCents != null ? centsToBrlInput(product.staticCostCents) : "",
    price: centsToBrlInput(product.priceCents),
    markupPercent: formatPercentInput(product.markupPercent),
    targetNetMarginPercent: formatPercentInput(product.targetNetMarginPercent),
    effectiveTaxPercent: formatPercentInput(product.effectiveTaxPercent),
  };
}

export function toProductPricingInput(
  productId: string,
  values: ProductPricingFormValues,
  bomLines: ProductBomLine[]
): ProductInput {
  const validBomLines = bomLinesToInput(bomLines);
  const input: ProductInput = {
    id: productId,
    priceCents: parseBrlToCents(values.price),
    markupPercent: parseOptionalPercent(values.markupPercent),
    targetNetMarginPercent: parseOptionalPercent(values.targetNetMarginPercent),
    effectiveTaxPercent: parseOptionalPercent(values.effectiveTaxPercent),
    staticCostCents: values.staticCost.trim() === "" ? null : parseBrlToCents(values.staticCost),
  };

  if (validBomLines.length > 0) {
    input.rawItems = validBomLines;
  } else {
    input.rawItems = [];
    if (values.cost.trim() !== "") {
      input.costCents = parseBrlToCents(values.cost);
    }
  }

  return input;
}
